<template>
  <div class="c-overdetail-wrapper">
    <m-content v-model="height" :total="total">
      <div class="c-filter">
        <dl class="c-form">
          <dt>素材ID：</dt>
          <dd>
            <span class="info-mini" v-clipboard:copy="imageId" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ imageId }}</span>
          </dd>
          <dt>素材名称：</dt>
          <dd>
            <span class="info-mini" v-clipboard:copy="name" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ name }}</span>
          </dd>
          <dt>素材类型：</dt>
          <dd>
            <span>{{ type }}</span>
          </dd>
        </dl>
        <div class="c-contorl-btn">
          <DateRangePicker v-model="datetime" :clearable="false" style="width: 220px"></DateRangePicker>
          <ElButton style="margin-left: 10px" icon="md-download" @click="downData">数据导出</ElButton>
          <ElButton @click="modalColumn = true">自定义列</ElButton>
        </div>
      </div>
      <m-table ref="overDetailTable" :data="tableData" :height="tableHeight" :loading="loading" @header-dragend="headerDragend">
        <el-table-column
          v-for="(col, id) in tableCol"
          :key="id + col.key"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <span v-if="['amount', 'pv', 'clickNum', 'downNum', 'cpi', 'payNum', 'payMoney', 'totalPlay'].includes(col.key)">{{
              scope.row[col.key] | toThousands
            }}</span>
            <span
              v-else-if="['ctr', 'cvr', 'roi', 'over2sPlay', 'over25Play', 'over3sPlay', 'over50Play', 'over100Play'].includes(col.key)"
              >{{ scope.row[col.key] | toPercentFixed }}</span
            >
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </m-table>

      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page"
        slot="pagination"
        size="small"
        v-if="total"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </m-content>

    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="tableColumns" :subTitle="['基础数据']" @on-select="selectCustomColumn" />
  </div>
</template>
<script>
import { HOST_API } from '@/api/config'
import { isArray } from '@/common/js/utils'
import mixinTable from '../materials/mixin_table'
import tableColumns from '../data/overseas_detail_column'
import CustomColumn from '@/components/converter/custom-column.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'

import { getOverseasDetailPage } from '@/api/report.model'
export default {
  name: 'OverseasDetail',
  mixins: [mixinTable],
  components: { CustomColumn, DateRangePicker },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => !ret.show)
    },
    tableHeight() {
      return this.height - 46
    }
  },
  data() {
    const { imageId, mediaId, name, type } = this.$route.query
    return {
      datetime: [],
      height: 0,
      tableData: [],
      tableColumns: [],
      imageId,
      mediaId,
      name,
      type
    }
  },
  watch: {
    datetime: {
      handler() {
        this.getData()
      },
      deep: true
    },
    tableColumns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => `${met.key}${met.width ? `|${met.width}` : ''}`)
        this.setCustomStorage('OverseasDetailCustomColumn', show)
        this.$nextTick(() => {
          this.$refs.overDetailTable && this.$refs.overDetailTable.doLayout()
        })
      },
      deep: true
    }
  },
  methods: {
    getData() {
      if (!isArray(this.datetime) || !this.datetime.length) return
      this.loading = true
      getOverseasDetailPage({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        beginTime: this.datetime[0],
        endTime: this.datetime[1],
        materialId: this.imageId,
        mediaId: Number(this.mediaId)
      })
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.initTableColumns()
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
            this.$nextTick(() => {
              this.$refs.overDetailTable && this.$refs.overDetailTable.doLayout()
            })
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    initTableColumns() {
      const shows = this.getCustomStorage('OverseasDetailCustomColumn') // 同步本地存储自定义列
      if (shows.length) {
        this.tableColumns = tableColumns
          .sort((a, b) => {
            const idxA = shows.findIndex((ret) => ret.includes(a.key))
            const idxB = shows.findIndex((ret) => ret.includes(b.key))
            const sortA = idxA < 0 ? idxA : shows.length - idxA
            const sortB = idxB < 0 ? idxB : shows.length - idxB
            return sortB - sortA
          })
          .map((ret) => {
            const shifRet = shows.filter((met) => met && met.includes('|') && met.includes(ret.key)).shift()
            ret.show = !shows
              .filter((met) => met)
              .map((met) => (met.includes('|') ? met.split('|').shift() : met))
              .includes(ret.key)
            shifRet && (ret.width = parseInt(Number(shifRet.split('|').pop() || '')))
            return ret
          })
      } else this.tableColumns = [...tableColumns]
    },
    downData() {
      const [begin, end] = this.datetime
      let url = `${HOST_API}/api/ptom/overseas/downReport`
      url += `?sessionid=${this.$store.state.token}&type=2`
      url += `&materialId=${encodeURIComponent(this.imageId)}`
      url += `&mediaId=${this.mediaId}`
      url += `&beginTime=${begin}`
      url += `&endTime=${end}`
      window.open(url)
    },
    headerDragend({ n, column }) {
      const index = this.tableColumns.findIndex((ret) => ret.key === column.property)
      index > -1 && this.$set(this.tableColumns[index], 'width', n)
    },
    selectCustomColumn(params) {
      const tableColumns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.$set(this, 'tableColumns', tableColumns)
      this.modalColumn = false
    },
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    }
  },
  created() {
    const { beginTime, endTime } = this.$route.query
    this.datetime = [beginTime, endTime]
  }
}
</script>
<style lang="scss" scoped>
.c-overdetail-wrapper {
  height: 100%;

  .c-filter {
    padding-top: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;

    dl.c-form {
      line-height: 22px;
      font-size: 14px;

      dd,
      dt {
        display: inline-block;
      }

      dt {
        font-weight: 600;
      }

      dd {
        padding-right: 26px;

        .info-mini {
          display: inline-block;
          vertical-align: middle;
          max-width: 220px;
        }
      }
    }
  }

  .c-table-page {
    font-size: 12px;
    padding: 0 8px;
    margin-top: 5px;
    text-align: right;
  }
}
</style>
